import styled from "styled-components";
import Image from "next/image";

const BenefitContainer = styled.div`
    text-align: center;
    color: #fff;
    padding: 30px;

    .content {
        text-align: left;
    }

    .media {
        height: 200px;
        border-bottom: 1px solid rgba(190, 190, 190, 0.25);
        margin-bottom: 20px;
    }
`;

type BenefitProps = {
    iconUrl: any;
    iconAlt?: string;
    children: any;
};

const Benefit: React.FC<BenefitProps> = ({ iconUrl, iconAlt = "", children }) => {
    return (
        <BenefitContainer>
            <div className="media">
                <Image src={iconUrl} alt={iconAlt} />
            </div>

            <div className="content">
                {children}
            </div>
        </BenefitContainer>
    );
};

export default Benefit;
